import PropTypes from 'prop-types'
import React, { Component } from 'react'

import ListItem from './ListItem'

export default class ReleaseTabOpen extends Component {

  static propTypes = {
    data: PropTypes.object
  }

  render() {
    const { data } = this.props
    const openList = data.collection
      .filter((itm) => {
        return !(itm.isToBeDeleted || itm.dirtyStatus || itm.isDeactivated)
      })
    const toBeDeletedList = data.collection.filter((itm) => itm.isToBeDeleted)

    return (
      <div>
        <h5>Freizugeben oder Abzulehnen</h5>
        <ul className="nav-list release-list vertical">
          {openList.map((itm) => (
            <ListItem
              key={itm.id}
              item={itm}
            />
          ))}
        </ul>

        <h5>Zu löschen</h5>
        <ul className="nav-list to-be-deleted-list vertical">
          {toBeDeletedList.map((itm) => (
            <ListItem
              key={itm.id}
              item={itm}
            />
          ))}
        </ul>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/release/components/TabOpen.js